// import { useState, useCallback } from 'react';
import styled from 'styled-components';
// import MapModal from '@components/modal/MapModal';
import DateFormatted from '@components/dateFormatted/DateFormatted';

const InfoItem = styled.div`
	min-width: 0;
	margin-bottom: 4px;
`;

const Label = styled.label`
	display: block;
	font-size: 10px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	color: ${({ theme }) => theme.colors.textAccent};
	opacity: 0.8;
	margin-bottom: 1px;
`;

const Value = styled.div`
	font-size: 12px;
	color: rgba(255, 255, 255, 0.95);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const InfoRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 4px;
`;

const MapLink = styled.button`
	background: none;
	border: none;
	padding: 0;
	font-size: 12px;
	color: ${({ theme }) => theme.colors.green};
	cursor: pointer;
	text-decoration: underline;
	text-underline-offset: 2px;

	&:hover {
		opacity: 0.8;
	}
`;

const StatusBadge = styled.span`
	display: inline-block;
	font-size: 10px;
	font-weight: 600;
	text-transform: capitalize;
	padding: 2px 8px;
	border-radius: 4px;
	color: #fff;
	background-color: ${({ $status }) => {
		switch ($status) {
			case 'finished':
			case 'uploaded':
				return '#27ae60';
			case 'pending':
			case 'processing':
				return '#f39c12';
			case 'failed':
			case 'error':
				return '#e74c3c';
			default:
				return '#6c757d';
		}
	}};
`;

const formatFileSize = sizeInBytes => {
	if (sizeInBytes == null) return null;
	if (sizeInBytes >= 1_000_000_000) return `${(sizeInBytes / 1_000_000_000).toFixed(1)} GB`;
	if (sizeInBytes >= 1_000_000) return `${(sizeInBytes / 1_000_000).toFixed(1)} MB`;
	if (sizeInBytes >= 1_000) return `${(sizeInBytes / 1_000).toFixed(0)} KB`;
	return `${sizeInBytes} B`;
};

const formatDrone = (manufacturer, model) => {
	const parts = [manufacturer, model].filter(Boolean);
	return parts.length ? parts.join(' ') : null;
};

const VideoSection = ({ video }) => {
	// const [showMap, setShowMap] = useState(false);

	// const openMap = useCallback(() => setShowMap(true), []);
	// const closeMap = useCallback(() => setShowMap(false), []);

	if (!video) return null;

	const fileSize = formatFileSize(video.file_size);
	// const drone = formatDrone(video.drone_manufacturer, video.drone_model);
	// const hasLocation = video.location?.latitude != null && video.location?.longitude != null;

	return (
		<>
			{/* Row 1: Filename + File size */}
			{video.video_filename && (
				<InfoItem>
					<Label>Filename</Label>
					<Value title={video.video_filename}>{video.video_filename}</Value>
				</InfoItem>
			)}

			{/* Row 2: Date captured */}
			<InfoRow>
				{fileSize && (
					<InfoItem>
						<Label>File size</Label>
						<Value>{fileSize}</Value>
					</InfoItem>
				)}
				{video.created_at && (
					<InfoItem>
						<Label>Date captured</Label>
						<Value>
							<DateFormatted
								inputDate={video.created_at}
								dateFormat="MMM d, yyyy h:mm a"
							/>
						</Value>
					</InfoItem>
				)}
			</InfoRow>

			{/* Row 3: Status */}
			{/* TODO: Re-enable Status when backend data is reliable */}
			{/*<InfoRow>
				{video.upload_status && (
					<InfoItem>
						<Label>Status</Label>
						<StatusBadge $status={video.upload_status}>
							{video.upload_status}
						</StatusBadge>
					</InfoItem>
				)}
			</InfoRow>*/}

			{/* TODO: Re-enable Drone and Location when backend data is reliable */}
			{/* <InfoRow>
				{drone && (
					<InfoItem>
						<Label>Drone</Label>
						<Value title={drone}>{drone}</Value>
					</InfoItem>
				)}
				{hasLocation && (
					<InfoItem>
						<Label>Location</Label>
						<MapLink type="button" onClick={openMap}>
							View on map
						</MapLink>
					</InfoItem>
				)}
			</InfoRow> */}

			{/* Row 4: FPS + Duration (if available) */}
			{(video.fps || video.duration_seconds != null) && (
				<InfoRow>
					{video.fps && (
						<InfoItem>
							<Label>FPS</Label>
							<Value>{video.fps}</Value>
						</InfoItem>
					)}
					{video.duration_seconds != null && (
						<InfoItem>
							<Label>Duration</Label>
							<Value>{video.duration_seconds}s</Value>
						</InfoItem>
					)}
				</InfoRow>
			)}

			{video.resolution_width && video.resolution_height && (
				<InfoRow>
					<InfoItem>
						<Label>Resolution</Label>
						<Value>
							{video.resolution_width}×{video.resolution_height}
						</Value>
					</InfoItem>
				</InfoRow>
			)}

			{/* TODO: Re-enable Location when backend data is reliable */}
			{/* {hasLocation && (
				<MapModal
					show={showMap}
					onClose={closeMap}
					latitude={video.location.latitude}
					longitude={video.location.longitude}
					title="Video Location"
				/>
			)} */}
		</>
	);
};

export default VideoSection;
